
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-094497cc!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RepositorioAcordo.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RepositorioAcordo.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-094497cc!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RepositorioAcordo.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RepositorioAcordo.vue
// module id = 83
// module chunks = 0